import { ResponseModel, getParameterByName } from "@r-and-a-shared-ui/utils";
import { ActionHandlerParams } from "../../types";
import { genericMutationHandlerWithFormValidation } from "../form-action-mutation-handlers";
import { RegisterInputSchema, userDefaultValuesRegister } from "@r-and-a-shared-ui/randa-trpc-server/input-schemas";
import { OauthQuery, getMembership } from "@r-and-a-shared-ui/auth-client";
import { sendGTMEvent } from '@next/third-parties/google';


export const handle = async (
  params: ActionHandlerParams,
): Promise<ResponseModel> => {
  params.submitData.redirectUri = getParameterByName(OauthQuery.REDIRECT_URI);
  params.submitData.redirectUriPath = getParameterByName(OauthQuery.REDIRECT_URI_PATH);
  const response = await genericMutationHandlerWithFormValidation(
    params,
    RegisterInputSchema,
    userDefaultValuesRegister,
  );

  if (!response?.hasErrors) {
    sendGTMEvent({ event: 'one_club_registration', value: { membership: getMembership(params) } });
  }

  return response;
};

export default handle;